





































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import PaymentInformation from "@/components/billing/PaymentInformation.vue";
import ProductOption from "@/components/membership/ProductOption.vue";
import { Urls } from "@/Urls";
import { BILLINGS as billingsDao } from "@/api/BillingsDao";
import { getModule } from "vuex-module-decorators";
import Users from "@/store/modules/Users";

const usersModule = getModule(Users);

@Component({
    components: { ProductOption, PaymentInformation }
})
export default class PricingPlans extends Vue {

    @Prop({type: String})
    coupon!: string;

    private couponCopy: null | string = null;
    private couponDetails: any = null;

    private products: any = null;

    get currentMembershipPlanId() {
        if (usersModule.currentUserMembership) {
            return usersModule.currentUserMembership.planId;
        }
    }

    mounted() {
        this.initialize();
    }

    private async initialize() {
        if (true || process.env.SERVER_ENV === 'production') {
            if (this.coupon) {
                this.couponCopy = this.coupon;
            } else {
                this.couponCopy = 'launch75';
            }
            await billingsDao.getCoupon(this.couponCopy)
            .then(result => {
                this.couponDetails = result;
            });
        }
        await billingsDao.getMembershipPlans()
        .then(membershipPlans => {
            this.products = membershipPlans.filter((plan: any) => (['Starter', 'Pro', 'Business'].includes(plan.name)));
            // this.products = membershipPlans.filter((plan: any) => (plan.name === 'Basic'));
        });
        console.log('products');
        console.log(this.products);
    }

    private get discountText() {
        if (!this.couponDetails || !this.couponDetails.valid) return '';

        if (this.couponDetails.name) {
            return this.couponDetails.name;
        } else if (this.couponDetails.percentOff) {
            return this.couponDetails.percentOff + '% off'
        } else if (this.couponDetails.amountOff) {
            return 'USD $' + this.couponDetails.amountOff / 100.0 + ' off'
        }
    }

    private select(itemId: string) {
        let location: any = {
            path: Urls.CHECKOUT,
            query: {
                product: itemId,
                successUrl: window.location.origin + Urls.APP + '?session_id={CHECKOUT_SESSION_ID}',
                cancelUrl: window.location.origin + this.$router.currentRoute.fullPath
            }
        }
        if (this.couponCopy) {
            location.query.coupon = this.couponCopy;
        }
        this.$router.push(location);
    }
}
